import service from "@irati/utils/tracking/index"

const tracking = {}


// Done
tracking.saveSurveySettings = () => {
  service.trackInsightsEvent("save_settings")
}
// Done
tracking.sendTestSurvey = () => {
  service.trackInsightsEvent("send_test_survey")
}
// Done
tracking.surveyEmployeeEngagementStatus = (schedule, DISABLED) => {
  if (schedule.status === DISABLED) {
    service.trackInsightsEvent("start_employee_engagement")
  } else {
    service.trackInsightsEvent("pause_employee_engagement")
  }
}
// Done
tracking.errorsEmployeeEngagement = () => {
  service.trackInsightsEvent("employee_engagement_error")
}
// V2
tracking.createSurveyActionPlan = () => {
  service.trackInsightsEvent("create_action_plan")
}
// V2
tracking.createSurveyReport = () => {
  service.trackInsightsEvent("create_survey_report")
}
// V2
tracking.shareSurveyReport = () => {
  service.trackInsightsEvent("share_survey_report")
}

export default tracking
